export default __webpack_public_path__ + "static/media/1128040325512718.4db4d907.jpg";